import styled from 'styled-components';
import {Glyphicon} from 'react-bootstrap';
import {Grey700} from '../../Colors';

const defaultStyle = {
	Description : styled.div`
		padding-bottom : 0.5rem;
		color : ${Grey700};
	`,
	InformationIcon : styled(Glyphicon).attrs({
		glyph : 'info-sign'
	})`
		margin-right : 0.5rem;
	`,
};

const mobileStyle = {
	Description : styled.div`
		padding-bottom : 1rem;
		color : ${Grey700};
	`,
};

export {mobileStyle};

export default defaultStyle;